import { Plugin } from '@nuxt/types';

interface ScrollToOptions {
  offset?: number;
  force?: boolean;
}

declare module 'vue/types/vue' {
  interface Vue {
    $scrollTo(element: Element | string, options?: ScrollToOptions): void;
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $scrollTo(element: Element | string, options?: ScrollToOptions): void;
  }

  interface Context {
    $scrollTo(element: Element | string, options?: ScrollToOptions): void;
  }
}

function isElementInViewport(el: Element): boolean {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const scrollTo = (element: Element | string, options: ScrollToOptions = {}): void => {
  const targetElement = typeof element === 'string' ? (document.querySelector(element) as Element | null) : element;

  if (!targetElement) return;

  const { offset = 0, force = false } = options;

  if (!force && isElementInViewport(targetElement)) return;

  const y = targetElement.getBoundingClientRect().top + window.scrollY + offset;

  window.scrollTo({
    top: y,
    behavior: 'smooth',
  });
};

const scrollToPlugin: Plugin = (_, inject) => {
  if (process.client) {
    inject('scrollTo', scrollTo);
  } else {
    inject('scrollTo', () => {});
  }
};

export default scrollToPlugin;
